import _ from 'lodash';
import dayjs from 'dayjs';
/**
 * Function returns detailed flight data
 */
const getDetailedFlightData = (flightDetails, currencySign) => {
  const { flightSegments, fareBreakdowns } = flightDetails;

  let data = 'The flight details are as follows: ';

  _.each(flightSegments, (segment, index) => {
    _.each(segment.flights, (flight) => {
      data += `\nSegment ${index + 1}:\n`;
      data += `- Carrier: ${flight.carrierFullName}\n`;
      data += `- Flight Number: ${flight.flightNumber}\n`;
      data += `- Departure Airport: ${flight.originAirportFullName} (${flight.originAirportCode})\n`;
      data += `- Arrival Airport: ${flight.destinationAirportFullName} (${flight.destinationAirportCode})\n`;
      data += `- Departure Time: ${dayjs(flight.departDateTime).format('MMM D, YYYY h:mm A')}\n`;
      data += `- Arrival Time: ${dayjs(flight.arriveDateTime).format('MMM D, YYYY h:mm A')}\n`;
      data += `- Duration: ${flight.duration} minutes\n`;
      data += `- Fare Price: ${currencySign}${flight.farePrice}\n`;
      data += `- Cabin Class: ${flight.cabinClassName}\n`;
      data += `- Refundable: ${flight.isRefundable ? 'Yes' : 'No'}\n`;
      data += `- Exchangeable: ${flight.exchangePolicy.beforeDeparture.isExchangeAble ? 'Yes' : 'No'}\n`;

      _.each(flight.allFares, (fare) => {
        data += '  Fare Option:\n';
        data += `  - Cabin Class: ${fare.cabinClassName}\n`;
        data += `  - Fare Basis Code: ${fare.fareBasisCode}\n`;
        data += `  - Refundable: ${fare.isRefundable ? 'Yes' : 'No'}\n`;
        data += `  - Fare Price: ${currencySign}${fare.price}\n`;
      });
    });
  });

  _.each(fareBreakdowns, (breakdown) => {
    if (breakdown?.passengerTotal) {
      data += `\nPassenger Type: ${breakdown.passengerType}\n`;
      data += `- Quantity: ${breakdown.passengerNumber}\n`;
      data += `- Base Fare: ${currencySign}${breakdown.passengerTotal.baseFare}\n`;
      data += `- Taxes and Fees: ${currencySign}${breakdown.passengerTotal.taxesAndFees}\n`;
      data += `- Total Per Traveler: ${currencySign}${breakdown.passengerTotal.totalPerTraveler}\n`;
    }
  });

  return data;
};

export default getDetailedFlightData;
